(ns common.schema.entities.sale-agreement.core
  (:require [common.schema.entities.permissions :as entity-permissions]
            [common.schema.entities.sale-agreement :as sale-agreement]))

;; Verbatim copy of common.schema.entity-types's existing sale-agreement entry
;; (entity_types.cljc around line 912-928) - required here, not there, to
;; avoid a circular namespace dependency (entity_types.cljc requires this
;; registry). Keep in sync if the original ever changes.
(defn- read-permissions-check-fn
  [{:keys [account-current-permissions]}]
  (contains? (:account-modules account-current-permissions)
             :module/sales-pipelines))

(def entity-type-definition
  {:entity-type                  :entity.type/sale-agreement
   :schema                       sale-agreement/schema
   :name                         {:en "Agreement"}
   :plural                       {:en "Agreements"}
   :icon                         :fa-file-signature
   :create-icon                  :fa-file-signature
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn entity-permissions/disable-when-no-write-permission

   ;; Unlike the other already-ported entities, sale-agreement has no
   ;; pre-existing legacy dedicated OpenSearch index (its legacy
   ;; common.opensearch.entity-indices entry only has :change-listening?
   ;; and :select-searchable?, no :dedicated-index?). Leaving :search-index?
   ;; unset lets it default to true (since :search is present below),
   ;; routing dedicated indexing through the newer
   ;; backend.search.dedicated.indexes/init! bootstrap - the index is
   ;; created and re-indexed explicitly as part of this port, see
   ;; ai/mistakes.md.
   :search                       {:result/title-attr :sale-agreement/name
                                  :list/default-columns [:sale-agreement/name
                                                         :sale-agreement/customer
                                                         :sale-agreement/won-by
                                                         :common/created-on]
                                  :views {:grid {:po-default-field-paths [[:sale-agreement/name]
                                                                          [:sale-agreement/customer]
                                                                          [:sale-agreement/won-by]
                                                                          [:common/created-on]]
                                                 :mandatory-field-paths [[:sale-agreement/name]
                                                                         [:sale-agreement/owner]
                                                                         [:sale-agreement/customer]]}}}})
